import { environment } from '../../../environment';
import { GetCacheDataParams, LavvaCacheData, SetCacheDataParams } from '../types';

const KEY = 'ZAMEL_CACHE';

const emptyData: LavvaCacheData = {
  version: '',
  common: {},
  perInstallation: {},
};

const getCurrentStorage = (): LavvaCacheData => {
  const cacheData = window.localStorage.getItem(KEY);
  return cacheData ? JSON.parse(cacheData) : { ...emptyData };
};

export const setCacheData = (params: SetCacheDataParams) => {
  const storageData = getCurrentStorage();

  const { kind } = params;

  if (kind === 'installation') {
    const { installationId, perInstallationData } = params;

    const perInstallation = storageData.perInstallation;

    const allCachedInstallationIds = Object.keys(perInstallation);

    if (!allCachedInstallationIds.includes(installationId) && allCachedInstallationIds.length >= 3) {
      const firstKey = allCachedInstallationIds[0];
      delete perInstallation[firstKey];
    }

    perInstallation[installationId] = {
      ...(perInstallation[installationId] || {}),
      ...perInstallationData,
    };
  }

  if (kind === 'common') {
    const { commonData } = params;

    storageData.common = {
      ...storageData.common,
      ...commonData,
    };
  }

  if (!storageData.version && environment.VERSION) {
    storageData.version = environment.VERSION;
  }

  window.localStorage.setItem(KEY, JSON.stringify(storageData));
};

export const getCacheData = <T>(params: GetCacheDataParams): T | null => {
  const storageData = getCurrentStorage();

  const { kind } = params;

  if (kind === 'installation') {
    const { installationId, key } = params;
    return (storageData.perInstallation[installationId]?.[key] as T) ?? null;
  }

  if (kind === 'common') {
    const { key } = params;
    return (storageData.common?.[key] as T) ?? null;
  }

  return null;
};

export const getCacheVersion = () => {
  const storageData = getCurrentStorage();
  return storageData.version;
};

export const clearCacheData = (newVersion: string) => {
  let storageData = getCurrentStorage();

  if (storageData) {
    storageData = {
      ...emptyData,
      version: newVersion,
    };

    window.localStorage.setItem(KEY, JSON.stringify(storageData));
  }
};
